import { render } from "./ClearAgencies.vue?vue&type=template&id=123345f4"
import script from "./ClearAgencies.vue?vue&type=script&lang=js"
export * from "./ClearAgencies.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__